import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["highlightPattern", "label"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Highlighter } from '../Highlighter/Highlighter';
import { StyledComboboxOption } from './ComboboxOption.styles';

/**
 * @since 8.28.0
 */
export var ComboboxOption = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var highlightPattern = _ref.highlightPattern,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  var labelNode = label;
  if (label && highlightPattern) {
    labelNode = /*#__PURE__*/React.createElement(Highlighter, {
      text: label,
      pattern: highlightPattern
    });
  }
  return /*#__PURE__*/React.createElement(StyledComboboxOption, _extends({
    ref: forwardedRef,
    label: labelNode
  }, rest));
});
ComboboxOption.displayName = 'ComboboxOption';
ComboboxOption.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Highlight the matched part of an option `label`.
   *
   * See `Highlighter` for more info.
   */
  highlightPattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
  /**
   * The label to display for this option.
   */
  label: PropTypes.string
} : {};